module.exports = __webpack_public_path__ + "img/pin-empty.199252ae.png";